<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Laporan - Ringkasan Penjualan</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>Dari</label>
            <flat-pickr class="form-control" v-model="options.fromDate"></flat-pickr>
        </div>
        <div class="form-group col-3">
            <label>Sampai</label>
            <flat-pickr class="form-control" v-model="options.toDate"></flat-pickr>
        </div>
        <div class="form-group col-md-3">
            <label for="sales-type">Tipe Penjualan</label>
            <select id="sales-type" class="form-control" v-model="options.type">
                <option value="" selected>Choose...</option>
                <option value="product">Product Sales</option>
                <option value="service">Service Sales</option>
            </select>
        </div>
        <div class="form-group col-md-3" style="text-align:center;">
            <label>Filter With Member</label>
            <input v-model="member.isFilterMember" type="checkbox" class="form-control">
        </div>
        <app-lookup-field v-if="this.member.isFilterMember" :model="member" :element="memberLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
    </div>
    <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button>
</div>
</template>

<script>
import AppLookupField from '../../../components/AppLookupField.vue'

export default {
    components: {
        AppLookupField
    },
    data() {
        return {
            member: {
                memberId: '',
                isFilterMember: false,
            },
            options: {
                fromDate: this.moment().format('YYYY-MM-DD'),
                toDate: this.moment().format('YYYY-MM-DD'),
                type: ''
            },
            memberLookup: {
                id: 'member',
                title: 'Member Data',
                type: 'form',
                apiUrl: 'member',
                filter: ['fullName', 'email', 'phoneNumber'],
                fields: [
                    {
                        placeholder: 'Nama Member',
                        width: 4,
                        column: 'memberName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'fullName'
                    },
                    {
                        title: 'Email',
                        column: 'email'
                    },
                    {
                        title: 'Phone',
                        column: 'phoneNumber'
                    }
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'memberId'
                    },
                    {
                        from: 'fullName',
                        to: 'memberName'
                    }
                ]
            },
        }
    },
    methods: {
        preview() {
            if(this.options.type !== '') {
                this.$router.push({
                    name: 'appRptSalesPrint',
                    query: {
                        fromDate: this.options.fromDate,
                        toDate: this.options.toDate,
                        type: this.options.type,
                        isFilterMember: this.member.isFilterMember,
                        memberId: this.member.memberId,
                    }
                })
            }
        },
        finishLookup(data) {
            const currentMember = this.member
            this.member = {
                ...currentMember,
                ...data
            }
        }
    }
}
</script>